export default "__VITE_ASSET__P3G1gjCk__"